import { lazy } from 'react';

const AdminPages = lazy(() =>
  import('@greenkub-fronts/pages/admin').then(({ AdminPages }) => ({
    default: AdminPages,
  }))
);

const ArchivesPages = lazy(() =>
  import('@greenkub-fronts/pages/archives').then(({ ArchivesPages }) => ({
    default: ArchivesPages,
  }))
);

const DashboardFeature = lazy(() =>
  import('@greenkub-fronts/pages/dashboard').then(({ DashboardFeature }) => ({
    default: DashboardFeature,
  }))
);

const PageQuoteTunnel = lazy(() =>
  import('@greenkub-fronts/pages/tunnel').then(({ PageQuoteTunnel }) => ({
    default: PageQuoteTunnel,
  }))
);

const PageR1Tunnel = lazy(() =>
  import('@greenkub-fronts/pages/tunnel').then(({ PageR1Tunnel }) => ({
    default: PageR1Tunnel,
  }))
);

const PageKitTunnel = lazy(() =>
  import('@greenkub-fronts/pages/tunnel').then(({ PageKitTunnel }) => ({
    default: PageKitTunnel,
  }))
);

const PageCustomerProjects = lazy(() =>
  import('@greenkub-fronts/pages/project/customer-projects').then(
    ({ PageCustomerProjects }) => ({ default: PageCustomerProjects })
  )
);

const InfoProjectFeature = lazy(() =>
  import('@greenkub-fronts/pages/project/info').then(
    ({ InfoProjectFeature }) => ({ default: InfoProjectFeature })
  )
);

const MainDocumentsPage = lazy(() =>
  import('@greenkub-fronts/pages/project/documents').then(
    ({ MainDocumentsPage }) => ({ default: MainDocumentsPage })
  )
);

const ChatFeature = lazy(() =>
  import('@greenkub-fronts/pages/project/chat').then(({ ChatFeature }) => ({
    default: ChatFeature,
  }))
);

const ConfigsFeature = lazy(() =>
  import('@greenkub-fronts/pages/project/upsell').then(
    ({ ConfigsFeature }) => ({
      default: ConfigsFeature,
    })
  )
);

const ProjectFeature = lazy(() =>
  import('@greenkub-fronts/pages/project/task').then(({ ProjectFeature }) => ({
    default: ProjectFeature,
  }))
);

const PublicSignaturePages = lazy(() =>
  import('@greenkub-fronts/pages/signature-pages').then(
    ({ PublicSignaturePages }) => ({
      default: PublicSignaturePages,
    })
  )
);

const TempDocumentFeature = lazy(() =>
  import('@greenkub-fronts/pages/signature-pages').then(
    ({ TempDocumentFeature }) => ({
      default: TempDocumentFeature,
    })
  )
);

const PrivateSignaturesPages = lazy(() =>
  import('@greenkub-fronts/pages/signature-pages').then(
    ({ PrivateSignaturesPages }) => ({
      default: PrivateSignaturesPages,
    })
  )
);

interface RouterProps {
  path: string;
  component: React.ReactElement | JSX.Element;
  protected: boolean;
  layout: boolean;
  withProjectNavigationBar?: boolean;
}

export const ROUTER: RouterProps[] = [
  // SOMMAIRE PROJECT D'UN CLIENT
  {
    path: 'customer/:customerId',
    component: <PageCustomerProjects />,
    protected: true,
    layout: true,
  },
  // LES PAGES D'UN PROJET
  {
    path: 'info/:projectId',
    component: <InfoProjectFeature />,
    protected: true,
    layout: true,
    withProjectNavigationBar: true,
  },
  {
    path: 'document/:projectId/*',
    component: <MainDocumentsPage />,
    protected: true,
    layout: true,
    withProjectNavigationBar: true,
  },
  {
    path: 'chat/:projectId',
    component: <ChatFeature />,
    protected: true,
    layout: true,
    withProjectNavigationBar: true,
  },
  {
    path: 'config/:projectId/*',
    component: <ConfigsFeature />,
    protected: true,
    layout: true,
    withProjectNavigationBar: true,
  },
  {
    path: 'task/:projectId/:projectAction/:iteration',
    component: <ProjectFeature />,
    protected: true,
    layout: true,
    withProjectNavigationBar: true,
  },
  {
    path: 'task/:projectId/:projectAction',
    component: <ProjectFeature />,
    protected: true,
    layout: true,
    withProjectNavigationBar: true,
  },
  {
    path: 'task/:projectId/*',
    component: <ProjectFeature />,
    protected: true,
    layout: true,
    withProjectNavigationBar: true,
  },
  // PAGES DE SIGNATURE ET DE PREPARATION SIGNATURE
  {
    path: 'signature/sign/*',
    component: <PublicSignaturePages />,
    protected: false,
    layout: false,
  },
  {
    path: 'devis/:token',
    component: <TempDocumentFeature />,
    protected: true,
    layout: false,
  },
  {
    path: 'signature/prepare/*',
    component: <PrivateSignaturesPages />,
    protected: true,
    layout: false,
  },
  // PAGE DE DEBUT DE TUNNEL QUOTE
  {
    path: 'quote/:projectId/:stepId',
    component: <PageQuoteTunnel />,
    protected: true,
    layout: false,
  },
  // PAGE DE DEBUT DE TUNNEL R1
  {
    path: 'r1/:projectId/:stepId',
    component: <PageR1Tunnel />,
    protected: true,
    layout: false,
  },
  // PAGE DE DEBUT DE TUNNEL KIT
  {
    path: 'geka/:projectId/:stepId',
    component: <PageKitTunnel />,
    protected: true,
    layout: false,
  },
  // ADMIN LISTE PAR DEFAULT ET PLAN DE PRINCIPE
  {
    path: 'admin/*',
    component: <AdminPages />,
    protected: true,
    layout: true,
  },
  // PAGE D'ARCHIVES
  {
    path: 'archives/*',
    component: <ArchivesPages />,
    protected: true,
    layout: true,
  },
  // DASHBOARD
  {
    path: '',
    component: <DashboardFeature />,
    protected: true,
    layout: true,
  },
];
